module.exports = __webpack_public_path__ + "img/banner_mobile.2a38b8f6.png";